import React from 'react';
import { styled } from 'linaria/react';
import CategoryLink from '@jetshop/ui/CategoryLink';
import { config } from '../../shop.config.custom';
import { theme } from '../Theming/Theming';
import Image from '@jetshop/ui/Image/Image';

const BrandWrapper = styled('div')`
  margin: 5px 0;
`;

const ImageWrapper = styled('div')`
  width: 100px;
`;

const SubName = styled('h5')`
  color: ${theme.colors.secondary};
`;

export const Brand = ({ product }) => {
  if (!product || !product.categories || product.categories.length === 0)
    return null;

  const subName = product.subName;

  const currentCategory = product.categories.filter(
    (cat) => cat.parentId === config.routes.brand.id
  )[0];

  return (
    <BrandWrapper>
      <>
        {currentCategory ? (
          <CategoryLink category={currentCategory}>
            {currentCategory.images?.length > 0 ? (
              <ImageWrapper>
                <Image
                  aspect={'5:3'}
                  crop={false}
                  src={currentCategory.images[4].url}
                  sizes={[200]}
                  quality={80}
                />
              </ImageWrapper>
            ) : (
              <SubName>{subName}</SubName>
            )}
          </CategoryLink>
        ) : (
          <SubName>{subName}</SubName>
        )}
      </>
    </BrandWrapper>
  );
};
